import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EditLogInfo } from '../model/editloginfo';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';

@Injectable({
  providedIn: 'root'
})
export class ChangelogService {

  constructor(private api: APIService) { }

  getChanges(assignmentNumber: string, actionType: string): Observable<ReturnObject<EditLogInfo[]>> {
    let endPoint = `logchanges/${assignmentNumber}/${actionType}`;
    return this.api.getAPI(endPoint);
  }
}
